export enum PiiSystemDataTypesFiltersEnum {
    Frameworks = 'Frameworks',
    Violations = 'Violations',
}

export enum PiiSystemDataTypeColumnsEnum {
    DataType = 'dataType',
    MatchesFound = 'matches',
    Frameworks = 'frameworks',
}